import { SHARED } from "./_shared.mjs";
/**
 * Returns true if the given value is a signal (either an Atom or a Computed).
 * @public
 */ export function isSignal(value) {
    if (typeof value !== "object" || value === null) return false;
    return SHARED.ATOM_BRAND in value || SHARED.COMPUTED_BRAND in value;
}
